import { render, staticRenderFns } from "./UnAuthorizedPage.vue?vue&type=template&id=707f5e95"
import script from "./UnAuthorizedPage.vue?vue&type=script&lang=js"
export * from "./UnAuthorizedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports